var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-md"},[(_vm.room)?_c('room-details',{attrs:{"room":_vm.room,"debug":_vm.debug,"sensor-data-getter":_vm.sensorDataGetter,"key-prefix":_vm.controllerId,"show-setpoints":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }